<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-08 18:18:41
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:12:34
 * @Description: file content
 -->

<template>
  <div v-if="isShowUserCard">
    <div
      v-bind:class="{usercard:true, animated:true,fadeInDown:isShowAni,fadeOutUp:isHideAni}"
      v-if="isShowMyCard"
    >
      <!-- <div class="top">
        <div class="head">
          <img :src="cardInfo.Ui.HeadImg" alt />
        </div>
        <div class="fields">
          <div class="field">
            <span class="value">{{cardInfo.Ui.Name}}</span>
          </div>
          <div class="field">
            <span class="label">电话</span>
            <span class="value">
              <a :href="'tel:'+cardInfo.User.Phone">{{cardInfo.User.Phone}}</a>
            </span>
          </div>
          <div class="field">
            <span class="label">微信</span>
            <span class="value">{{cardInfo.User.Wechat}}</span>
          </div>
          <div class="field">
            <span class="value company">{{cardInfo.User.Company}}</span>
          </div>
        </div>
      </div>-->
      <div class="top">
        <div class="head">
          <img :src="cardInfo.Ui.HeadImg" alt />
        </div>
        <div class="fields">
          <div class="field">
            <span v-if="isInMiniProgram" class="value company">
              <span>{{cardInfo.Ui.Name}}</span>
              <span>{{' '+cardInfo.User.Company}}</span>
            </span>
            <span v-else class="value company company-web">
              <span>{{cardInfo.Ui.Name}}</span>
              <span>{{' '+cardInfo.User.Company}}</span>
            </span>
          </div>
          <div class="field">
            <span class="label">电话</span>
            <span class="value">
              <a :href="'tel:'+cardInfo.User.Phone">{{cardInfo.User.Phone}}</a>
            </span>
          </div>
          <div class="field">
            <span class="label">微信</span>
            <span class="value">{{cardInfo.User.Wechat}}</span>
          </div>
        </div>
      </div>
      <div class="bottom" v-if="isShowGuide">
        <div v-for="item in navData" class="item" @click="clickItem(item)">
          <img :src="item.ico" alt />
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="btn" @click="clickChangeMy" v-if="isShowGuide&&btnChageMyTxt">{{btnChageMyTxt}}</div>
      <div v-if="isMyCard&&isShowMyCard" class="hidecard" @click="clickCardHide">隐藏</div>
      <HdkShare v-if="isShowGuide&&isShowHdkShare" v-on:close="closeHdkShare"></HdkShare>
      <ShareGuide v-if="isShowGuide&&isShowShareGuide" v-on:close="closeShareGuide"></ShareGuide>
      <ShowImg2
        v-if="isShowGuide&&showImg2.isShow"
        :my="showImg2"
        v-on:close="showImg2.isShow=false"
      ></ShowImg2>
    </div>
    <div v-if="isMyCard&&!isShowMyCard" class="showcard" @click="clickCardShow">展开名片</div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import wxsdk from "@/utils/wxsdk";
const HdkShare = () => import("@/components/hdk-share.vue");
const ShareGuide = () => import("@/components/share_guide3.vue");
const ShowImg2 = () => import("@/components/showimg2.vue");
export default {
  components: {
    HdkShare,
    ShareGuide,
    ShowImg2
  },
  props: {},
  data() {
    return {
      isShowUserCard: false,
      navData: [
        {
          name: "电话",
          click: "clickCall",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_phone2.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_phone2.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_phone2.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "咨询",
          click: "clickChat",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_chat2.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_chat2.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_chat2.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "微信",
          click: "clickWx",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_wechat2.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_wechat2.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_wechat2.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "分享",
          click: "clickShare",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_share2.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_share2.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/usercard3/card_icon_share2.png?x-oss-process=image/resize,h_100,w_100"
        }
      ],
      btnChageMyTxt: "", //卡片按钮，两种模式：1、编辑 2、换成我的
      isShowHdkShare: false, //是否显示分享
      isShowShareGuide: false, //是否显示网页分享
      isShowImg: false,
      showImgUrl: "",
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isMyCard: false, //是我自己的名片。展示隐藏 展示操作按钮。
      isShowAni: false,
      isHideAni: false
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "isShowMyCard"
    ])
  },
  methods: {
    ...mapMutations({
      SET_CARDINFO: "SET_CARDINFO",
      SET_ISSHOWMYCARD: "SET_ISSHOWMYCARD",
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO"
    }),
    // 编辑或换成我的
    clickChangeMy() {
      const that = this;
      if (this.btnChageMyTxt == "编辑") {
        if (this.hdkUserInfo.isRegister) {
          // 已注册，跳转到编辑个人信息
          if (this.isInMiniProgram) {
            let backurl = `/pages/webview/common/common?cuid=${
              this.hdkUserInfo.User.Id
            }&url=${encodeURIComponent(location.href)}`;
            wxsdk.wx.miniProgram.navigateTo({
              url: `/pages/hdk/modify/modify?backurl=${encodeURIComponent(
                backurl
              )}`
            });
          } else {
            // 已注册，获取编辑个人信息小程序码
            comreq
              .wxAcode(that, "pages/hdk/modify/modify")
              .then(function(data) {
                if (data) {
                  that.showImg2 = {
                    isShow: true,
                    url: data,
                    width: "50%",
                    intro: "扫码，修改信息！"
                  };
                } else {
                  util.messageBox("获取小程序码失败！");
                }
              });
          }
        } else {
          // 未注册，跳转到注册页
          if (this.isInMiniProgram) {
            util.openMinProgramRegister(this);
          } else {
            // 未注册，获取注册页小程序码
            comreq
              .wxAcode(that, "pages/hdk/register/register")
              .then(function(data) {
                if (data) {
                  that.showImg2 = {
                    isShow: true,
                    url: data,
                    width: "50%",
                    intro: "扫码，免费获取AI获客神器！"
                  };
                } else {
                  util.messageBox("获取小程序码失败！");
                }
              });
          }
        }
      } else if (this.btnChageMyTxt == "换成我的") {
        util.switchToMine(this).then(data => {
          that.isMyCard = true;
          that.SET_ISSHOWMYCARD(true);
          if (data == 1) {
            that.btnChageMyTxt = "编辑";
          } else if (data == 4) {
            comreq
              .wxAcode(that, "pages/hdk/register/register")
              .then(function(data) {
                if (data) {
                  that.showImg2 = {
                    isShow: true,
                    url: data,
                    width: "50%",
                    intro: "扫码，免费获取AI获客神器！"
                  };
                } else {
                  this.messageBox("获取小程序码失败！");
                }
              });
          }
        });
      }
    },
    clickItem(item) {
      this[item.click]();
    },
    // 电话
    clickCall() {
      comreq.actAdv(this, this.$enumUserEvent.call);
      location.href = "tel:" + this.cardInfo.User.Phone;
    },
    // 聊天
    clickChat() {
      comreq.actAdv(this, this.$enumUserEvent.spreadChat);
      util.openChat(this);
    },
    // 微信
    clickWx() {
      if (
        this.cardInfo &&
        this.cardInfo.User &&
        this.cardInfo.User.WechatQrImg
      ) {
        if (this.isInMiniProgram) {
          util.navigateToShareMomentsPageContainImg(
            this,
            {
              title: "点击获取经纪人的个人二维码",
              desc: "点击查看",
              img: this.cardInfo.Ui.HeadImg,
              sendMessageTitle: "点击获取经纪人的个人二维码",
              sendMessageImg:
                "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon7.png",
              intro: "长按扫码，添加经纪人的个人微信"
            },
            this.cardInfo.User.WechatQrImg
          );
        } else {
          that.showImg2 = {
            isShow: true,
            url: this.cardInfo.User.WechatQrImg,
            width: "50%",
            intro: `扫码，添加${this.cardInfo.Ui.Name}的微信！`
          };
        }
      } else if (
        this.cardInfo &&
        this.cardInfo.User &&
        this.cardInfo.User.Wechat
      ) {
        util.messageBox(`我的微信号是：${this.cardInfo.User.Wechat}`);
      } else {
        comreq.registerNotify(this);
        util.messageBox("亲，您可以用电话联系我");
      }
    },
    // 分享
    clickShare() {
      if (this.isInMiniProgram) {
        this.isShowHdkShare = true;
      } else {
        this.isShowShareGuide = true;
      }
    },
    // 关闭小程序分享
    closeHdkShare() {
      this.isShowHdkShare = false;
    },
    // 关闭网页分享引导
    closeShareGuide() {
      this.isShowShareGuide = false;
    },
    getCardWxAcode() {
      let that = this;
      return new Promise(function(resolve, reject) {
        comreq.wxAcode(that, "pages/hdk/intro/intro").then(function(data) {
          if (data) {
            resolve(data);
          } else {
            reject();
          }
        });
      });
    },
    // 隐藏卡片
    clickCardHide() {
      this.isShowAni = false;
      this.isHideAni = true;
      setTimeout(() => {
        this.SET_ISSHOWMYCARD(false);
      }, 500);
      comreq.updatePageUserSetting(this, 1);
    },
    // 展示卡片
    clickCardShow() {
      this.isHideAni = false;
      this.isShowAni = true;
      this.SET_ISSHOWMYCARD(true);
      comreq.updatePageUserSetting(this, 0);
    }
  },
  created() {
    const that = this;
    // 原来的
    // util.checkMapStateCallback(this, ["userInfo", "cardInfo"]).then(() => {
    //   console.log("this.userInfo", that.userInfo);
    //   console.log("this.cardInfo", that.cardInfo);
    //   if (
    //     that.userInfo &&
    //     that.userInfo.user &&
    //     that.cardInfo &&
    //     that.cardInfo.Wxuser &&
    //     that.userInfo.user.unionid == that.cardInfo.Wxuser.Unionid
    //   ) {
    //     // 如果名片是自己的
    //     that.btnChageMyTxt = "编辑";
    //   } else {
    //     // 如果名片是别人的
    //     if (
    //       that.pageInfo &&
    //       that.pageInfo.Create_mode &&
    //       that.pageInfo.Create_mode == "hdk_peerhelp"
    //     ) {
    //       // 如果是同行发布不展示”换成我的“按钮
    //     } else if (that.$pageType == that.$enumPageType.vcard) {
    //       // 如果是智能名片页不展示”换成我的“按钮
    //     } else {
    //       that.btnChageMyTxt = "换成我的";
    //     }
    //   }
    //   // 获取名片人的小程序码
    //   that.getCardWxAcode().then(function(mpQrCode) {
    //     let tmpCardInfo = that.cardInfo;
    //     that.SET_CARDINFO(null);
    //     tmpCardInfo.mpQrCode = mpQrCode;
    //     that.SET_CARDINFO(tmpCardInfo);
    //   });
    //   that.isShowUserCard = true;
    // });

    util
      .checkMapStateCallback(this, ["userInfo", "cardInfo", "pageInfo"])
      .then(() => {
        /**
         * 同行发布
         * 始终展示创建人的，仅仅在创建人打开的时候显示编辑
         */
        if (
          that.pageInfo &&
          that.pageInfo.Create_mode &&
          that.pageInfo.Create_mode == "hdk_peerhelp"
        ) {
          // 名片不是创建人的,获取创建人的很多客小程序信息
          if (that.cardInfo.User.Id != that.pageInfo.Actuuid) {
            comreq
              .findUserById(that.pageInfo.Actuuid)
              .then(function(actUserInfo) {
                that.SET_CARDINFO(actUserInfo);
                // 获取名片人的小程序码
                that.getCardWxAcode().then(function(mpQrCode) {
                  that.SET_CARDINFO(null);
                  actUserInfo.mpQrCode = mpQrCode;
                  that.SET_CARDINFO(actUserInfo);
                  that.isShowUserCard = true;
                });
              });
          } else {
            // 获取名片人的小程序码
            that.getCardWxAcode().then(function(mpQrCode) {
              let tmpCardInfo = that.cardInfo;
              that.SET_CARDINFO(null);
              tmpCardInfo.mpQrCode = mpQrCode;
              that.SET_CARDINFO(tmpCardInfo);
              that.isShowUserCard = true;
            });
          }
        } else if (that.$pageType == that.$enumPageType.vcard) {
          /**
           * 智能名片
           * 仅仅在是自己的名片下展示“编辑”
           */
          if (
            that.userInfo &&
            that.userInfo.user &&
            that.cardInfo &&
            that.cardInfo.Wxuser &&
            that.userInfo.user.unionid == that.cardInfo.Wxuser.Unionid
          ) {
            that.btnChageMyTxt = "编辑";
          }
          // 获取名片人的小程序码
          that.getCardWxAcode().then(function(mpQrCode) {
            let tmpCardInfo = that.cardInfo;
            that.SET_CARDINFO(null);
            tmpCardInfo.mpQrCode = mpQrCode;
            that.SET_CARDINFO(tmpCardInfo);
            that.isShowUserCard = true;
          });
        } else {
          /**
           * 内容页面
           */
          // 如果名片是自己的
          if (
            that.userInfo &&
            that.userInfo.user &&
            that.cardInfo &&
            that.cardInfo.Wxuser &&
            that.userInfo.user.unionid == that.cardInfo.Wxuser.Unionid
          ) {
            that.btnChageMyTxt = "编辑";
          } else {
            // 如果名片是别人的
            that.btnChageMyTxt = "换成我的";
          }
          // 获取名片人的小程序码
          that.getCardWxAcode().then(function(mpQrCode) {
            let tmpCardInfo = that.cardInfo;
            that.SET_CARDINFO(null);
            tmpCardInfo.mpQrCode = mpQrCode;
            that.SET_CARDINFO(tmpCardInfo);
            that.isShowUserCard = true;
          });
        }

        // 如果是自己的名片就展示名片的隐藏展示操作按钮
        if (
          that.userInfo &&
          that.userInfo.user &&
          that.cardInfo &&
          that.cardInfo.Wxuser &&
          that.userInfo.user.unionid == that.cardInfo.Wxuser.Unionid
        ) {
          that.isMyCard = true;
        }
        //我的名片始终不展示隐藏
        if (that.$pageType == that.$enumPageType.vcard) {
          that.isMyCard = false;
        }
        if (that.pageInfo.PageUserSetting) {
          if (that.pageInfo.PageUserSetting.cardhidden == 0) {
            that.SET_ISSHOWMYCARD(true);
          } else if (that.pageInfo.PageUserSetting.cardhidden == 1) {
            that.SET_ISSHOWMYCARD(false);
          }
        } else {
          that.SET_ISSHOWMYCARD(true);
        }
      });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
a {
  color: #333;
}
.usercard {
  background-image: url("https://assets.rurushishi.com/yq-rs-make/components/usercard3/bg2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: auto;
  font-size: 12px;
  margin: 7px 7px 0 7px;
  position: relative;
  padding-bottom: 0.3rem;
}
.usercard .top {
  display: flex;
}

.usercard .top .head {
  min-width: 2rem;
  text-align: center;
  padding-top: 0.4rem;
}
.usercard .top .head img {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.6rem;
}

.usercard .top .fields {
  padding-top: 0.2rem;
}
.usercard .top .fields > .field {
  line-height: 0.5rem;
  display: flex;
}
.usercard .top .fields > .field > span {
  display: block;
}
.usercard .top .fields > .field .label {
  padding-right: 0.1rem;
  white-space: nowrap;
  color: #8b8b8b;
}
.usercard .top .fields > .field .value {
  padding-right: 0.2rem;
}
.usercard .top .fields > .field > .company span:first-child {
  color: #333333;
  font-weight: 600;
}
.usercard .top .fields > .field > .company span:nth-child(2) {
  color: #333333;
}
.usercard .top .fields > .field > .company-web {
  overflow: hidden;
  display: inline-block;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.usercard .bottom {
  display: flex;
  justify-content: center;
  align-items: center;
}
.usercard .bottom .item {
  width: 100%;
  text-align: center;
  margin-top: 0.2rem;
  /* margin-bottom: 0.4rem; */
  position: relative;
}
.usercard .bottom .item img {
  width: 25px;
  height: 25px;
}
.usercard .bottom .item span {
  display: block;
  font-size: 10px;
  color: #333333;
  padding-top: 5px;
}

.usercard .btn {
  position: absolute;
  top: 35px;
  right: 20px;
  width: 1.5rem;
  height: 26px;
  line-height: 26px;
  border-radius: 0.35rem;
  color: #f46060;
  text-align: center;
  font-size: 12px;
  border: 1px solid #f46060;
}
/* 隐藏名片 */
.usercard .hidecard {
  position: absolute;
  top: 0;
  right: 0;
  color: #333333;
  width: 40px;
  height: 30px;
  line-height: 28px;
  background-color: #ffffff;
  border-bottom-left-radius: 30px;
  border-top: 1px solid #d6e7f7;
  border-right: 1px solid #d6e7f7;
  border-top-right-radius: 5px;
  font-size: 12px;
  text-indent: 12px;
}
/* 展开名片 */
.showcard {
  position: fixed;
  top: 2rem;
  right: 10px;
  height: 30px;
  width: 80px;
  line-height: 30px;
  text-align: center;
  background: rgba(35, 35, 35, 1);
  box-shadow: 0px 1px 4px 0px rgba(153, 153, 153, 0.49);
  opacity: 0.88;
  color: #ffffff;
  border-radius: 20px;
  font-size: 12px;
  z-index: 1;
}
</style>